import { createSlice } from "@reduxjs/toolkit";
const initialPurchaseOrderReturnState = {
  entities: [],
  totalCount: 0,
  purchaseToReturn: null,
  completed: false,
  returnEntity: null,
  listLoading: false,
  actionsLoading: false,
  returnDate: null,
  returnReason: null,
  selectedReturn: null,
  isIndependentReturn: false,
  particularReceive: {},
  resumeReturn:false,
  purchaseOrder: { supplier: {}, channel: {} },
  edit: false,
  editReturnDetails: [],
  editIndependantReturn: false,
  message: {
    error: null,
    success: null,
    cartError: null,
    cartSuccess: null,
    couponSuccess: null,
    couponError: null,
    warning: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};
export const purchaseReturnsSlice = createSlice({
  name: "purchaseReturns",
  initialState: initialPurchaseOrderReturnState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.message.success = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    independentReturn: (state, action) => {
      state.isIndependentReturn = action.payload;
    },
    purchaseOrder: (state, action) => {
      state.purchaseOrder = action.payload.purchaseOrder;
    },
    setChannelInPurchaseOrder: (state, action) => {
      state.purchaseOrder.channel = action.payload 
    },
    setChannel: (state, action) => {
      try{
        state.selectedReturn.channel_id= action.payload.selectedChannel.value || 1
      }catch(err) {
        state.selectedReturn = {}
        state.selectedReturn.channel_id= action.payload.selectedChannel.value || 1
        console.error(err)
      }
    },
    setSupplierInPurchaseOrderForIndependentReturn: (state, action) => {
      state.purchaseOrder.supplier = action.payload 
    },
    removeSupplier: (state, action) => {
      state.supplier = null;
    },
    purchaseReceive: (state, action) => {
      // debugger;
      state.particularReceive = action.payload;
      state.purchaseOrder = action.payload.purchase_order
    },
    purchaseOrderReturned: (state, action) => {
      const { message, warnings, entity } = action.payload;
      state.actionsLoading = false;
      state.message.success = message;
      state.message.warning = warnings;
      state.returnEntity = entity;
      state.returnDate = null;
      state.returnReason = null;
      state.completed = true;
    },
    purchaseReturnUpdated: (state, action) => {
      const { message, warnings, entity } = action.payload;
      state.actionsLoading = false;
      state.message.success = message;
      state.message.warning = warnings;
      state.returnEntity = entity;
      state.returnDate = null;
      state.returnReason = null;
      state.completed = true;
    },
    setPurchaseReceivedProducts: (state, action) => {
      state.purchase_receives = action.payload.purchase_receives
    },
    setPurchaseToReturn: (state, action) => {
      state.message.success = null;
      const { purchaseToReturn } = action.payload;
      state.completed = false;
      state.purchaseToReturn = purchaseToReturn;
    },
    // change order status
    changeOrderStatus: (state, action) => {
      state.actionsLoading = false;
      state.message.success = "Status Changed Successfully";
      state.message.error = null;
      const { entity } = action.payload;
      state.entities = state.entities.map((row) => {
        if (entity.id === row.id) {
          row = entity;
        }
        return row;
      });
    },
    changedResponseMessage: (state, action) => {
      state.message.success = null;
    },
    // Purchase return fetched
    purchaseReturnsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.entities = entities;
      // state.entities = entities.map((row) => {
      //   row.grandeTotal = 0;
      //   row.purchase_return_details.map((innerRow) => {
      //     row.grandeTotal += innerRow.total_price;
      //   });
      //   return row;
      // });
      state.totalCount = totalCount;
    },
    // selected Return for Edit
    setSelectedReturn: (state, action) => {
      const { orderReturn } = action.payload;
      console.log("🚀 ~ orderReturn:", orderReturn)
      state.selectedReturn = orderReturn;
      state.purchaseOrder = orderReturn.purchase_order
      state.editReturnDetails = orderReturn.purchase_return_details
      state.purchaseOrder.supplier = orderReturn.purchase_order?.supplier || {}
      state.purchaseOrder.channel = orderReturn.purchase_order?.channel || {}
      state.selectedReturn.channel_id = orderReturn.purchase_return_details?.channel
      // state.edit = true;
    },
    // edit return
    setEditReturn: (state, action) => {
      state.edit = action.payload;
    },
    setCloneMode: (state, action) => {
      state.cloneMode = action.payload;
    },
    // edit independant return
    setIndependantReturnEdit: (state, action) => {
      state.editIndependantReturn = action.payload;
    },
    //change complete status
    changeCompleteStatus: (state, action) => {
      const { status } = action.payload;
      state.completed = status;
    },
    // reset states
    resetStates: (state, action) => {
      state.entities = [];
      state.totalCount = 0;
      state.purchaseToReturn = null;
      state.completed = false;
      state.returnEntity = null;
      state.listLoading = false;
      state.actionsLoading = false;
      state.returnDate = null;
      state.returnReason = null;
      state.selectedReturn = null;
      state.edit = false;
      state.cloneMode = false;
      state.editIndependantReturn = false;
      state.purchaseOrder = { supplier: {}, channel: {} };
      state.isIndependentReturn = false;
      state.particularReceive = {};
      state.editReturnDetails = [];
      state.message = {
        error: null,
        success: null,
        cartError: null,
        cartSuccess: null,
        couponSuccess: null,
        couponError: null,
        warning: null,
      };
    },
    setReturnDate: (state, action) => {
      state.returnDate = action.payload;
    },
    setReturnReason: (state, action) => {
      state.returnReason = action.payload;
    },
    setCompleted: (state, action) => {
      state.completed = action.payload;
    },
    resetPurchaseReturnState: (state, action) => {
      state.entities = [];
      state.totalCount = 0;
      state.purchaseToReturn = null;
      state.completed = false;
      state.listLoading = false;
      state.actionsLoading = false;
      state.returnDate = null;
      state.returnReason = null;
      state.message = {
        error: null,
        success: null,
        cartError: null,
        cartSuccess: null,
        couponSuccess: null,
        couponError: null,
        warning: null,
      };
    },
    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "warning":
          state.message.warning = message;
          break;
        case "success":
          state.message.success = message;
          break;
        case "couponSuccess":
          state.message.couponSuccess = message;
          break;
        case "couponError":
          state.message.couponError = message;
          break;
        case "cartSuccess":
          state.message.cartSuccess = message;
          break;
        case "cartError":
          state.message.cartError = message;
          break;
        default:
          break;
      }
    },
    setRetrievedReturn: (state, action) => {
          const  order  = action.payload.return;
          state.resumeReturn = action.payload.resumeReturn;
          state.retrievedOrder = order;
          state.supplier = order?.supplier;
          state.supplier_id = order?.supplier.id;
          state.returnDate = order?.returning_date;
          state.returnReason = order?.return_reason;
          state.files = order?.files;
        },
        resetRetrievedReturn: (state, action) => {
          state.retrievedReturn = null;
          state.resumeReturn = false
        },
        setSearchedProducts: (state, action) => {
          state.products = action.payload;
        },
        addSupplier: (state, action) => {
          state.actionsLoading = false;
          state.error = null;
          state.supplier = action.payload.supplier;
          state.entities = [];
        },
  },
});
